import {
  Button,
  Flex,
  HStack,
  Heading,
  IconButton,
  LinkBox,
  LinkOverlay,
  StackProps,
  UseDisclosureReturn
} from "@chakra-ui/react"
import { IconName } from "@pathwright/pathicons"
import Pathicon from "@pathwright/web/src/modules/pathicon/Pathicon"
import Link, { LinkHref, LinkRelativeTo, LinkTo } from "../link/Link"

// TODO: rename this as CardLink is too specific.
// Component probably doesn't even belong in Card folder.

type CardLinkProps = {
  label: string
  icon?: IconName
  to?: LinkTo
  relativeTo?: LinkRelativeTo
  href?: LinkHref
  onClick?: () => void
  disclosure?: UseDisclosureReturn
} & StackProps

function CardLink({
  label,
  icon,
  to,
  relativeTo,
  href,
  onClick,
  disclosure,
  ...stackProps
}: CardLinkProps) {
  const hasLink = !!to || !!relativeTo || !!href

  const iconButton = (
    <IconButton
      as="div"
      aria-label="Toggle"
      variant="ghost"
      colorScheme="blackAlpha"
      cursor="pointer"
      ml={2}
      h={8}
      minW={8}
      isRound
    >
      <Pathicon
        icon={
          disclosure?.isOpen
            ? "chevron-down"
            : href
            ? "external-link"
            : "chevron-right"
        }
      />
    </IconButton>
  )

  return (
    <HStack
      as={hasLink ? LinkBox : Button}
      variant="ghost"
      align="center"
      justify="space-between"
      w="100%"
      pointerEvents="auto"
      minW={200}
      p={2}
      borderRadius="20px"
      _hover={{ bg: "blackAlpha.200" }}
      cursor="pointer"
      onClick={onClick}
      {...disclosure?.getButtonProps({
        onClick
      })}
      {...stackProps}
    >
      <Flex align="center" gap={2}>
        {!!icon && <Pathicon icon={icon} />}
        <Heading
          minW={200}
          w="100%"
          as="h2"
          fontSize="sm"
          color="blackAlpha.900"
          m={0}
          textAlign="left"
        >
          {label}
        </Heading>
      </Flex>
      <Flex align="center">
        {hasLink ? (
          <LinkOverlay as={Link} to={to} relativeTo={relativeTo} href={href}>
            {iconButton}
          </LinkOverlay>
        ) : (
          iconButton
        )}
      </Flex>
    </HStack>
  )
}

export default CardLink
